import { RouterModule, Routes } from "@angular/router";

import { HomeComponent } from "./home/index";
import { LegacyLoginComponent } from "./login/legacy-login/legacy-login.component";
import { TwoFactorLoginComponent } from "./login/2fa-login/2fa-login.component";
import { environment } from "../environments/environment";
import { RegisterComponent } from "./register/index";
import { BrothersComponent } from "./brothers/index";
import { CheckoutComponent } from "./checkout/checkout.component";
import { ForgotPasswordComponent } from "./forgotpassword/forgotpassword.component";

import {
  PaymentNotOkComponent,
  PaymentOkComponent,
  RefundComponent,
} from "./payment";

import { ParentEventsPageComponent } from "./admin/events-screen/parent-events-page/parent-events-page.component";
import { CreateParentEventFormComponent } from "./admin/events-screen/create-parent-event-form/create-parent-event-form.component";
import { WhiteBoardComponent } from "./admin/events-screen/white-board/white-board.component";
import { EventTypeManagementScreenComponent } from "./admin/event-type-management/event-type-management-screen.component";
import { BrothersAttributionPage } from "./admin/brothers-attribution/brothers-attribution-page/brothers-attribution-page.component";
import { QuestionsAnswersComponent } from "./header/questionsanswers.component";
import { MeshutafUsersComponent } from "./admin/meshutaf-users/meshutaf-users.component";
import { AuthGuard } from "./_guards/auth.guard";
import { StagingGuard } from "./_guards/staging.guard";
import { UserManagementPageComponent } from "./admin/users/user-management-page/user-management-page.component";
import { EventMeshutafComponent } from "./admin/meshutaf/event-meshutaf.component";
import { AdminComponent } from "./admin/admin/admin.component";
import { ContentComponent } from "./admin/content/content.component";
import { RefundsAdminComponent } from "./admin/refunds/refundsAdmin.component";
import { MihlolComponent } from "./admin/mihlol/mihlol.component";
import { OpenReceiptsComponent } from "./admin/teshlumon/open-receipts/open-receipts.component";
import { PaymentsComponent } from "./admin/payments/payments.component";
import { RikuzComponent } from "./admin/rikuz/rikuz.component";
import { DevelopmentComponent } from "./development/development.component";
import { FigmaLinkComponent } from "./development/figma/figma.link.component";
import { StoriesComponent } from "./development/stories/stories.component";
import { RestUserPasswordComponent } from "./reset-user-password/rest-user-password.component";
import { DiscountManagementPageComponent } from "./admin/discounts/discount-management-page/discount-management-page.component";
import { LastStoriesComponent } from "./development/last-stories/last-stories.component";
import { ReceiptPageComponent } from "./admin/receipt/receipt-page/receipt-page.component";
import { ReceiptUtilTestsUploadComponent } from "./admin/receipt/receipt-util-tests-upload/receipt-util-tests-upload.component";
import { OrDevComponent } from "./or-dev/or-dev.component";
const appRoutes: Routes = [
  { path: "", component: HomeComponent, canActivate: [AuthGuard] },
  {
    path: "event/:child/:event",
    component: HomeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "profile/:registeredUser",
    component: HomeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "event-meshutaf/:event",
    component: EventMeshutafComponent,
    canActivate: [AuthGuard],
  },
  { path: "forgotpassword/:uid", component: ForgotPasswordComponent },
  {
    path: "forgotpassword",
    component: ForgotPasswordComponent,
  },
  { path: "forgot_password", component: RestUserPasswordComponent },
  { path: "reset-rakaz-password", component: RestUserPasswordComponent },
  {
    path: "login",
    component:
      environment.features && environment.features.twoFactorLogin
        ? TwoFactorLoginComponent
        : LegacyLoginComponent,
  },
  { path: "register", component: RegisterComponent },
  {
    path: "ok",
    component: PaymentOkComponent,
  },
  {
    path: "whiteboard",
    component: WhiteBoardComponent,
    canActivate: [StagingGuard],
  },
  {
    path: "events-demo",
    component: ParentEventsPageComponent,
    canActivate: [StagingGuard],
  },
  {
    path: "events-types-management",
    component: EventTypeManagementScreenComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "create-event-demo/:eventId",
    component: CreateParentEventFormComponent,
    canActivate: [AuthGuard],
  },
  { path: "notok", component: PaymentNotOkComponent },
  { path: "questions-answers", component: QuestionsAnswersComponent },
  {
    path: "brothers",
    component: BrothersComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "admin",
    component: AdminComponent,
    canActivate: [AuthGuard],
    children: [
      { path: "content", component: ContentComponent, outlet: "admin" },
      {
        path: "admin-refunds",
        component: RefundsAdminComponent,
        outlet: "admin",
      },
      { path: "mihlol", component: MihlolComponent, outlet: "admin" },
      {
        path: "admin-meshutaf-users",
        component: MeshutafUsersComponent,
        outlet: "admin",
      },
      {
        path: "open-receipts",
        component: OpenReceiptsComponent,
        outlet: "admin",
      },
      {
        path: "new-open-receipts",
        component: ReceiptPageComponent,
        outlet: "admin",
      },
      {
        path: "test-upload-file",
        component: ReceiptUtilTestsUploadComponent,
        outlet: "admin",
      },
      { path: "payments", component: PaymentsComponent, outlet: "admin" },
      { path: "rikuz", component: RikuzComponent, outlet: "admin" },
      {
        path: "events-management",
        component: ParentEventsPageComponent,
        outlet: "admin",
        canActivate: [AuthGuard],
      },
      {
        path: "brothers-attribution",
        component: BrothersAttributionPage,
        outlet: "admin",
        canActivate: [AuthGuard],
      },
      {
        path: "discounts",
        component: DiscountManagementPageComponent,
        outlet: "admin",
        canActivate: [AuthGuard],
      },
      {
        path: "user-management",
        component: UserManagementPageComponent,
        outlet: "admin",
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: "devtools",
    component: DevelopmentComponent,
    canActivate: [StagingGuard],
    children: [
      {
        path: "figma",
        component: FigmaLinkComponent,
      },
      {
        path: "stories/:id",
        component: StoriesComponent,
      },
      {
        path: "stories",
        component: StoriesComponent,
      },
      {
        path: "",
        component: LastStoriesComponent,
      },
    ],
  },
  {
    path: "admin-event-types",
    component: EventTypeManagementScreenComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "checkout",
    component: CheckoutComponent,
    canActivate: [AuthGuard],
  },
  { path: "refund", component: RefundComponent, canActivate: [AuthGuard] },

  {
    path: "or-dev",
    component: OrDevComponent,
    canActivate: [StagingGuard],
  },

  // otherwise redirect to home
  { path: "**", redirectTo: "" },
];

export const routing = RouterModule.forRoot(appRoutes);



// WEBPACK FOOTER //
// ./src/app/app.routing.ts